module.exports = __webpack_public_path__ + "img/6eb26bb.jpg";